export default "__VITE_ASSET__94082d1a__"